/* eslint-disable prefer-template */
import React from 'react';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import uuid from 'react-uuid';
import { Button, Label } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../redux/modals/modalReducer';
import ModalWrapper from '../../../common/modals/ModalWrapper';
import MyTextInput from '../../../common/form/MyTextInput';
import MyDateInput from '../../../common/form/MyDateInput';
import MySelectInput from '../../../common/form/MySelectInput';

export default function CorrectiveFormEdit() {
  const { currentError } = useSelector((state) => state.authReducer);

  const dispatch = useDispatch();

  const { users } = null;
  const { currentUserProfile } = null;
  const { conformite } = null;

  const usersOptions = users.map((user) => ({
    key: user.id,
    text: user.firstname + ' ' + user.lastname,
    value: user.firstname + ' ' + user.lastname,
    image: {
      avatar: true,
      src: user.photoURL
    }
  }));

  const initialValues = {
    description: '',
    userTraitement: '',
    userSuivi: '',
    datePrevu: ''
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().required(
      "Description de l'action corrective et préventive est un champ obligatoire"
    ),
    userTraitement: Yup.string().required('Responsable de traitement est un champ obligatoire'),
    userSuivi: Yup.string().required('Responsable de traitement est un champ obligatoire'),
    datePrevu: Yup.string().required('Date au plus tard prévue est un champ obligatoire')
  });

  const handleSubmit = (values) => {
    try {
      const payload = {
        id: uuid(),
        description: values.description,
        userTraitement: values.userTraitement,
        userSuivi: values.userSuivi,
        datePrevu: values.datePrevu,
        userId: currentUserProfile.id,
        qseId: conformite.qseId
      };
      alert(JSON.stringify(payload, null, 2));

      dispatch(closeModal());
      // console.log(JSON.stringify(payload, null, 2));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalWrapper size="mini" header="Sign in to Re-vents">
      {currentError && (
        <Label basic color="red" style={{ marginBottom: 10 }} content={currentError} />
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form className="ui form">
            <MyTextInput
              label="Description de l'action corrective et préventive"
              name="description"
              placeholder="Description de l'action corrective et préventive"
            />
            <MySelectInput
              label="Responsable de traitement"
              name="userTraitement"
              placeholder="Responsable de traitement"
              options={usersOptions}
            />

            <MySelectInput
              label="Responsable de suivi"
              name="userSuivi"
              placeholder="Responsable de suivi"
              options={usersOptions}
            />
            <MyDateInput
              label="Date au plus tard prévue"
              name="datePrevu"
              placeholderText="Date au plus tard prévue"
              timeFormat="HH:mm"
              showTimeSelect
              timeCaption="time"
              dateFormat="MMMM d, yyyy h:mm a"
              autoComplete="off"
            />
            <Button
              loading={isSubmitting}
              disabled={!isValid || !dirty || isSubmitting}
              type="submit"
              fluid
              size="large"
              color="blue"
              content="Ajouter"
            />
          </Form>
        )}
      </Formik>
    </ModalWrapper>
  );
}
